import { IEnrichedFlight } from '../../../shared/flight/domain/models/IEnrichedFlight';
import { normalizeSearchValue } from '../../../shared/normalizeSearchValue';

export function createFlightSearchFilter(queryString: string) {
	const query = normalizeSearchValue(queryString);

	return (flight: IEnrichedFlight) => {
		const searchableStrings: string[] = [];

		const {
			airlineDetails,
			operatingAirlineFlightNumber,
			arrival,
			arrivalAirportDetails,
			departureAirportDetails,
		} = flight;

		if (airlineDetails) {
			const { iata, name } = airlineDetails;
			const values = [iata, name].filter((value) => value);
			searchableStrings.push(...values);
		}

		if (arrival && departureAirportDetails) {
			const { iata, name, city } = departureAirportDetails;
			const values = [iata, name, city].filter((value) => value) as string[];
			searchableStrings.push(...values);
		}

		if (!arrival && arrivalAirportDetails) {
			const { iata, name, city } = arrivalAirportDetails;
			const values = [iata, name, city].filter((value) => value) as string[];
			searchableStrings.push(...values);
		}

		if (operatingAirlineFlightNumber) {
			searchableStrings.push(operatingAirlineFlightNumber);
		}

		return searchableStrings.some((str: string) =>
			normalizeSearchValue(str).includes(query),
		);
	};
}
